import type { FC, PropsWithChildren } from 'react';
import { Divider } from 'antd';
import styled from 'styled-components';

export const StyledDivider = styled(Divider)`
  &&& {
    font-size: 12px;
    margin: 0;
    text-transform: uppercase;
  }
`;

export const DateRangePickerDivider: FC<PropsWithChildren> = ({ children }) => (
  <StyledDivider plain orientationMargin={0}>
    {children}
  </StyledDivider>
);
